import React, { useMemo } from "react";

import { SelectInput } from "react-admin";
import { useFieldLabel } from "ra-friendsofbabba";
import { useFormState } from "react-final-form";

const MonthMapInput = ({ config, dep, ...props }) => {
  const { values } = useFormState({ subscription: { values: true } });
  const fieldLabel = useFieldLabel({ ...props });
  const choices = useMemo(() => {
    if (dep) {
      const value = parseInt(values[dep], 10);
      const max = config?.data?.map[value];
      const choices = [];
      for (let i = 1; i <= max; i++) {
        choices.push({
          id: i,
          name: i,
        });
      }
      return choices;
    }
    const map = Object.keys(config?.data?.map || {}).map((id) => ({
      id: parseInt(id, 10),
      name: id,
    }));
    return map;
  }, [config, dep, values]);
  return (
    <SelectInput
      {...props}
      disabled={choices.length === 0}
      choices={choices}
      optionText="id"
      translateChoice={false}
      helperText={fieldLabel(`${props.source}.help`)}
    />
  );
};

export default MonthMapInput;
